import React from "react";
import {connect} from "react-redux";
import LoginForm from "./Form";
import {triggerLogin} from "../../epics/login";
import {CHATS} from "../../reducers/router";
import {Alert} from 'antd';

class Login extends React.Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth && nextProps.auth.authenticated) {
            nextProps.dispatch({
                type: CHATS
            })
        }
    }

    submitForm = (values) => {
        triggerLogin(this.props.dispatch, values);
    };

    render() {
        return (
            <div style={{maxWidth: 500, margin: '50px auto'}}>
                {
                    this.props.auth.error ?
                        <Alert style={{height: 'initial'}} message={this.props.auth.error} type="error"/>
                        :
                        <span></span>
                }

                <LoginForm submit={this.submitForm}/></div>
        )
    }
}

const mapState = ({auth}) => ({auth});
export default connect(mapState)(Login)



// WEBPACK FOOTER //
// ./src/components/login/Login.js